// 管理番号の形式: 英大文字5桁 + 数字5桁 = 10文字 (例: GCLMQ71010)
export const COMPANY_MANAGEMENT_NUMBER_REGEX = /^[A-Z]{5}\d{5}$/;
export const COMPANY_MANAGEMENT_NUMBER_ERROR_MESSAGE = "無効な企業IDの形式です。期待される形式: 英大文字5桁+数字5桁 (例: GCLMQ71010)";
